export default "__VITE_ASSET__0dfaef97__"